import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

@Component({
  selector: 'mau-environment-banner',
  templateUrl: './environment-banner.component.html',
  styleUrls: ['./environment-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnvironmentBannerComponent {
  readonly environment = input<'development' | 'testing' | 'staging' | 'production'>('development');

  @HostBinding('class.testing') get isTesting() {
    return this.environment() === 'testing';
  }

  @HostBinding('class.staging') get isStaging() {
    return this.environment() === 'staging';
  }

  @HostBinding('class.development') get isDevelopment() {
    return this.environment() === 'development';
  }
}
